import React, { useState, useEffect, useRef } from "react";
import Tab1Image from "../img/envision/healthcare/bfsinew/bfsi1.jpg";
import Tab2Image from "../img/envision/healthcare/bank2.jpg";
import Tab3Image from "../img/envision/healthcare/bfsinew/nabordaudit.jpg";
import Tab4Image from "../img/envision/healthcare/bfsinew/sebi cybersecurity.jpg";
import Tab5Image from "../img/envision/healthcare/bfsinew/swift.jpg";
import Tab6Image from "../img/envision/aerospace/tabsimages/bfsidataprotaction.jpg";
import Tab7Image from "../img/envision/healthcare/bfsinew/bfsi2.jpg";
import Tab8Image from "../img/envision/healthcare/bfsinew/uidai.jpg"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const BankingVerticalTabs = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay

  const tabContainerRef = useRef(null);
  const navigate = useNavigate(); // Initialize navigate

  // const handleKnowMoreClick = () => {
  //   // Navigate to the documentaerospacepage with the specific hash
  //   navigate("/documentBfsipage#documentBfsipageone");
  // };

  const handleKnowMoreClick = (tabId) => {
    console.log("Navigating to:", tabId);
    navigate(`/documentBfsipage?activeTab=${tabId}#documentBfsipageone`);
  
    setTimeout(() => {
      const targetElement = document.getElementById("documentAutomotivaPageone");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 700);
  };
  const [isHovered, setIsHovered] = useState(false);
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
  };
  // Autoplay effect to change tabs every 3 seconds (3000ms)
  useEffect(() => {
    let tabInterval;

    if (!isHovered && isAutoPlayActive) {
      tabInterval = setInterval(() => {
        setActiveTab((prevTab) => {
          const nextTabNum = parseInt(prevTab.replace("tab", "")) % 7 + 1;
          return `tab${nextTabNum}`;
        });
      }, 3000);
    }

    return () => clearInterval(tabInterval);
  }, [activeTab, isHovered, isAutoPlayActive]);

useEffect(() => {
        if (tabContainerRef.current) {
            const container = tabContainerRef.current;
            const activeTabElement = document.getElementById(activeTab);

            if (activeTabElement) {
                // Get the position of the active tab within the container
                const activeTabOffsetTop = activeTabElement.offsetTop;

                // Smoothly scroll the container to that position
                container.scrollTo({
                    top: activeTabOffsetTop - container.offsetTop, // Adjust based on the container's offset
                    behavior: 'smooth', // Smooth scroll
                });
            }
        }
    }, [activeTab]);

    
  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      // display: "flex",
      width: "80%",
      margin: "50px auto",
    },
    tabNav: {
      // display: "flex",
      flexDirection: "column",
      borderRight: "1px solid #fff",
      height: "350px",
      overflowY: "auto", // Ensure only vertical scrolling
      scrollbarWidth: "thin", // For Firefox
      scrollbarColor: "#ccc transparent", // For Firefox
      direction: "rtl", // This makes the scrollbar appear on the left side
    },

    tabButton: {
      padding: "15px",
      cursor: "pointer",
      border: "none",
      background: "none",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#555",
      outline: "none",
      transition: "color 0.3s, background-color 0.3s",
      borderRadius: "10px",
      margin: "5px 0",
      backgroundColor: "#f0f0f0",
    },
    activeTabButton: {
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
    },
    card: {
      // display: "flex",
      alignItems: "center",
      padding: "20px",
      borderRadius: "15px",
      backgroundColor: "#fff",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
      width: "100%",
      // marginLeft:"10px",
      cursor: "pointer",
      height: "350px",
      overflowY: "auto"
    },
    image: {
      width: "382px",
      height: "274px",
      borderRadius: "10px",
      marginRight: "20px",
    },
    textContent: {
      flex: 1,
      textAlign: "left",
      color: "#333",
    },
    icon: {
      marginRight: "10px",
      fontSize: "24px",
      color: "#009ca5",
    },
    dotNav: {
      display: "flex",
      justifyContent: "center",
      marginTop: "10px",
    },
    dot: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#ccc",
      margin: "0 5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    activeDot: {
      backgroundColor: "rgb(236 115 34)",
    },
    knowMoreButton: {
      marginTop: "15px",
      padding: "10px 20px",
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s",
      // marginLeft: "150px"
    },
    knowMoreButtonHover: {
      backgroundColor: "#e68a00",
    },
  };

  return (
    <div>
      <h1 style={{ textAlign: "center" }}>
        <span style={{ color: "rgb(236 115 34)" }}>Regulatory Compliance </span>Services
      </h1>
      <div style={styles.container} className="tabclass-container-data">
      



        <div
          style={{
            ...styles.tabNav,
            overflowY: 'auto', // Allow scrolling within the container
            scrollBehavior: 'smooth', // Enable smooth scrolling within the container
          }}
          ref={tabContainerRef}
          className="tabdata"
        >
          {[
            'RBI (Reserve Bank of India) Audit compliance',
            'IRDAI Audit compliance',
            'NABARD Audit compliance',
            'SEBI Cybersecurity & Resilience Audit compliance',
            'SWIFT CSCF Assessment Audit compliance',
            'UIDAI - AUA & KUA Compliance Audit',
            'DPDP Compliance'

          ].map((tab, index) => {
            const tabId = `tab${index + 1}`;
            return (
              <button
                key={tabId}
                id={tabId}
                style={{
                  ...styles.tabButton,
                  ...(activeTab === tabId
                    ? { ...styles.activeTabButton, backgroundColor: 'rgb(236 115 34)', color: '#fff' }
                    : {}),
                }}
                onClick={() => handleTabClick(tabId)}
                className="tab-button-width"
                onMouseEnter={(e) => {
                  if (activeTab !== tabId) {
                    e.currentTarget.style.backgroundColor = '#000'; // Change background to black on hover
                    e.currentTarget.style.color = '#fff'; // Change text to white on hover
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tabId) {
                    e.currentTarget.style.backgroundColor = ''; // Revert background on mouse leave
                    e.currentTarget.style.color = ''; // Revert text color on mouse leave
                  }
                }}
              >
                {tab}
              </button>
            );
          })}
        </div>

        <div style={styles.card} className="card-data-vertica-tabs" onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}>
          <img
            src={{ tab1: Tab1Image, tab2: Tab7Image, tab3: Tab3Image, tab4: Tab4Image, tab5: Tab5Image, tab6: Tab8Image, tab7: Tab2Image, tab8: Tab3Image, tab9: Tab6Image }[activeTab]}
            alt="Healthcare"
            style={styles.image}
            className="tab-image-data"
          />
         
          <div style={styles.textContent}>
            {/* Render content based on the activeTab */}
            <p
              style={{
                textAlign: "justify",
                // marginTop: "120px",
                whiteSpace: "pre-line",
              }}
              // className="bank-tb-one-data"

              className={`bank-tb-one-data 
                ${activeTab === "tab2" }
                 ${activeTab === "tab5" }
                ${activeTab === "tab7" }
               
                `
              
              
              }
            >
              {
                [
                  "Across a diverse spectrum of BFSI entities, the Reserve Bank of India (RBI) mandates rigorous annual audits to uphold financial integrity, security, and sound banking practices. \n\n These audits encompass critical domains such as the RBI Payment and Settlement Systems Audit, RBI Data Localization Audit (SAR), RBI Cooperative Bank IS Audit, RBI PA & PG Audit, and adherence to RBI Cybersecurity Guidelines for NBFCs and Banks.  \n \n Each of these assessments plays a pivotal role in ensuring regulatory compliance, fortifying cybersecurity resilience, and enhancing the robustness of financial systems  ",
                  "The Insurance Regulatory and Development Authority of India (IRDA) has established a comprehensive baseline framework, mandating that all insurance service providers sell products exclusively through the Insurance Self Network Platform (ISNP). To ensure regulatory adherence, IRDA has outlined stringent compliance guidelines for these platforms and conducts annual audits to verify that insurance companies, aggregators, and intermediaries align with ISNP regulations. \n \n Additionally, IRDA has developed a robust and dynamic framework encompassing privacy, data protection, information security, and cybersecurity. This framework is designed to proactively address evolving security challenges faced by insurance companies and regulated entities. Through rigorous annual audits, IRDA ensures that industry participants maintain compliance, fortify their security posture, and uphold the integrity of digital insurance services. ",
                  "The National Bank for Agriculture and Rural Development (NABARD) has established a robust regulatory framework for Regional Cooperative Banks (RCBs) and Regional Rural Banks (RRBs) to safeguard customer data integrity and enforce stringent security controls. \n \n Under this framework, RRBs and RCBs are classified into four distinct levels based on their degree of digital adoption, integration with the payment systems landscape, and technological maturity. Each category is subject to rigorous security control requirements, ensuring a structured and scalable approach to cybersecurity, data protection, and financial integrity across all levels of the rural banking ecosystem . ",
                  "The Securities and Exchange Board of India (SEBI) has established a comprehensive Cyber Resilience Framework to ensure a robust cybersecurity posture and safeguard the integrity of data and privacy across the financial ecosystem.  \n\n This framework mandates strict compliance from all Stockbrokers, Depository Participants, Mutual Funds, Asset Management Companies (AMCs), Stock Exchanges, Clearing Corporations, and Depositories, reinforcing their resilience against cyber threats.  \n \n By implementing these stringent cybersecurity measures, SEBI aims to fortify the financial markets against evolving digital risks, ensuring operational continuity and investor protection. ",
                  "The Society for Worldwide Interbank Financial Telecommunications (SWIFT) has established a robust security framework under its Customer Security Program (SWIFT CSP) to enhance security, transparency, and resilience across the global financial community. This initiative is designed to combat the rising threats of cyber fraud by enforcing stringent security measures for all SWIFT users \n \n At the core of SWIFT CSP is the Customer Security Control Framework (CSCF), which outlines a set of mandatory security controls, principles, and objectives that are revised and strengthened annually. This framework not only mandates the implementation of critical security controls but also promotes a community-wide information-sharing initiative to proactively detect and prevent fraudulent activities. \n \n Organizations utilizing the SWIFT interbank messaging network must adhere to these evolving cybersecurity standards and the assurance framework, ensuring compliance with global best practices in financial security and risk mitigation .",
                  "Enrolling with the Unique Identification Authority of India (UIDAI) enables organizations to provide E-KYC and Aadhaar-based authentication, facilitating seamless and secure identity verification. \n \n Organizations seeking empanelment as a KYC User Agency (KUA) or integration with Aadhaar Authentication Services (AUA) must undergo a comprehensive security assessment and obtain a compliance certification. This rigorous assessment ensures adherence to UIDAI's security standards and specifications, reinforcing data protection, privacy, and  regulatory compliance for all entities leveraging Aadhaar authentication services ",
                  "The Digital Personal Data Protection (DPDP) Act, 2023, establishes a robust regulatory framework to ensure the responsible processing, storage, and protection of personal data across industries, including the Banking, Financial Services, and Insurance (BFSI) sector. \n \n  Under this act, BFSI entities handling sensitive financial and personal data must implement stringent data governance practices, including obtaining explicit consent, ensuring lawful data processing, and adhering to data minimization principles. The act mandates compliance with data security obligations, requiring financial institutions, insurance companies, fintech firms, and other regulated entities to implement adequate safeguards against unauthorized access, data breaches, and cyber threats. \n \n To enforce compliance, BFSI organizations must conduct periodic data audits, Non-compliance with the DPDP Act, 2023, can result in substantial penalties, making it imperative for BFSI organizations to adopt a privacy-by-design approach, integrate robust security frameworks, and enhance their data protection posture to maintain customer trust and regulatory adherence. ",

                ][parseInt(activeTab.replace("tab", "")) - 1]
              }
            </p>

            {Array.from({ length: 7 }, (_, index) => {
              const tabId = `tab${index + 1}`;
              return (
                activeTab === tabId && (
                  <button key={tabId} onClick={() => handleKnowMoreClick(tabId)}
                    style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                    className="know-more-btn"
                  >
                    Know More
                  </button>
                )
              );
            })}
          </div>
        </div>
      </div>

      {/* Dot Navigation */}
      <div style={styles.dotNav}>
        {[...Array(7)].map((_, index) => {
          const tab = `tab${index + 1}`;
          return (
            <div
              key={tab}
              style={{
                ...styles.dot,
                ...(activeTab === tab ? styles.activeDot : {}),
              }}
              onClick={() => handleTabClick(tab)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default BankingVerticalTabs;
